var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import { TableHeading } from '@/typings';
import TableMixin from '@/mixins/table-mixin';
import BaseTable from '@/components/base/BaseTable.vue';
import { TYPES } from '@/dependency-injection/types';
var ManageGroupTable = /** @class */ (function (_super) {
    __extends(ManageGroupTable, _super);
    function ManageGroupTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headers = [
            new TableHeading('Name', 'name'),
            new TableHeading('Description', 'description'),
            new TableHeading('Associated Carriers', 'id', false),
            new TableHeading('Actions', 'id', false),
        ];
        return _this;
    }
    ManageGroupTable.prototype.beforeMount = function () {
        this.serviceSymbol = TYPES.CarrierGroupService;
    };
    /**
     * Custom filter for searching carrier (child) name
     * in addition to other columns
     */
    ManageGroupTable.prototype.groupsSearchFilter = function (value, search, item) {
        search = search.toLowerCase();
        return ((item.name && item.name.toLowerCase().includes(search)) ||
            (item.description && item.description.toLowerCase().includes(search)) ||
            item.carriers.filter(function (c) { return !c.name || c.name.toLowerCase().includes(search); }).length > 0);
    };
    ManageGroupTable = __decorate([
        Component({
            components: {
                'base-table': BaseTable,
            },
        })
    ], ManageGroupTable);
    return ManageGroupTable;
}(Mixins(TableMixin)));
export default ManageGroupTable;
